// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history {
  background-color: #ffffff;
  padding: 40px 20px 30px 25px;
  position: relative;
  width: 1130px;
  border: 0.5px solid #cbcbcb;
  /* border-top: 0; */
}

.history .history-param {
  position: absolute;
  top: -140px;
  left: -2px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.history .history-param .select-search select {
  border: 0.5px solid #016aa7;
  width: 130px;
  border-radius: 4px;
  padding: 9px;
  background-color: transparent;
  color: #016aa7;
}

.history .history-summary {
  border: 1px solid;
  border-radius: 8px;
  text-align: center;
  height: 130px;
}

.merchant-name {
  color: #3482f5;
  font-size: 10px;
}

.history-table {
  margin-top: 20px;
  /* height: 350px; */
  border-top: 0.5px solid #d6d6d6;
  overflow-x: auto;
  white-space: nowrap;
}

.export-btn {
  border: 0.5px solid #016aa7;
  color: #016aa7;
  padding: 10px;
  border-radius: 4px;
  background-color: transparent;
  text-decoration: none;
  box-shadow: none;
}

.page-btn {
  border: none;
  margin-inline: 5px;
}

.paging {
  position: absolute;
  right: 0px;
  top: -80px;
}

.paging-content {
  margin-bottom: 15px;
  color: #495057;
}

.paging-content p {
  margin-bottom: 0px;
}

.paging .current-page {
  background-color: #f2f2f2;
  border: 1px solid #d4d9de;
  border-radius: 4px;
  padding: 10px 15px;
  margin-right: 15px;
}

.paging .page-scroll {
  margin-right: 15px;
  padding: 10px;
}

.history .export {
  position: absolute;
  right: 0px;
  top: -50px;
}

.history .reason-msg {
  font-size: 10px;
  color: #152c5b;
}

.history .reason-count {
  font-size: 20px;
  margin-top: 12px;
  margin-bottom: 0;
  color: #091c46;
  font-weight: 600;
}

.history .summary-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin-inline: auto;
}

.history .summary-icon .fa-solid {
  margin-left: 15px;
  padding-right: 15px;
  font-size: 15px;
}

.history .history-table .service-logo {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.slick-slide {
  width: 250px !important;
  margin-right: 15px;
}

.slick-arrow.slick-disabled:before {
  color: #000;
}

.slick-prev:before {
  color: #000 !important;
}

.slick-next {
  right: -15px !important;
}

.slick-next:before {
  color: #000 !important;
}`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/card-transactions/transaction-dashboard/History.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".history {\n  background-color: #ffffff;\n  padding: 40px 20px 30px 25px;\n  position: relative;\n  width: 1130px;\n  border: 0.5px solid #cbcbcb;\n  /* border-top: 0; */\n}\n\n.history .history-param {\n  position: absolute;\n  top: -140px;\n  left: -2px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.history .history-param .select-search select {\n  border: 0.5px solid #016aa7;\n  width: 130px;\n  border-radius: 4px;\n  padding: 9px;\n  background-color: transparent;\n  color: #016aa7;\n}\n\n.history .history-summary {\n  border: 1px solid;\n  border-radius: 8px;\n  text-align: center;\n  height: 130px;\n}\n\n.merchant-name {\n  color: #3482f5;\n  font-size: 10px;\n}\n\n.history-table {\n  margin-top: 20px;\n  /* height: 350px; */\n  border-top: 0.5px solid #d6d6d6;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n.export-btn {\n  border: 0.5px solid #016aa7;\n  color: #016aa7;\n  padding: 10px;\n  border-radius: 4px;\n  background-color: transparent;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.page-btn {\n  border: none;\n  margin-inline: 5px;\n}\n\n.paging {\n  position: absolute;\n  right: 0px;\n  top: -80px;\n}\n\n.paging-content {\n  margin-bottom: 15px;\n  color: #495057;\n}\n\n.paging-content p {\n  margin-bottom: 0px;\n}\n\n.paging .current-page {\n  background-color: #f2f2f2;\n  border: 1px solid #d4d9de;\n  border-radius: 4px;\n  padding: 10px 15px;\n  margin-right: 15px;\n}\n\n.paging .page-scroll {\n  margin-right: 15px;\n  padding: 10px;\n}\n\n.history .export {\n  position: absolute;\n  right: 0px;\n  top: -50px;\n}\n\n.history .reason-msg {\n  font-size: 10px;\n  color: #152c5b;\n}\n\n.history .reason-count {\n  font-size: 20px;\n  margin-top: 12px;\n  margin-bottom: 0;\n  color: #091c46;\n  font-weight: 600;\n}\n\n.history .summary-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  margin-inline: auto;\n}\n\n.history .summary-icon .fa-solid {\n  margin-left: 15px;\n  padding-right: 15px;\n  font-size: 15px;\n}\n\n.history .history-table .service-logo {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n}\n\n.slick-slide {\n  width: 250px !important;\n  margin-right: 15px;\n}\n\n.slick-arrow.slick-disabled:before {\n  color: #000;\n}\n\n.slick-prev:before {\n  color: #000 !important;\n}\n\n.slick-next {\n  right: -15px !important;\n}\n\n.slick-next:before {\n  color: #000 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
